import type { TeamHistoryFields } from '../types'

/**
 * The official from the reader's own list who is the team's current official,
 * or null when the team has none or it is not in the list.
 *
 * Matched by id: the team endpoint and the reader's officials list share the
 * official record's id.
 */
export const findTeamCurrentOfficial = <T extends { id?: string | null }>(
  team: Pick<TeamHistoryFields, 'team_official'> | null | undefined,
  officials: T[] | null | undefined
): T | null => {
  const officialId = team?.team_official?.id
  if (!officialId) {
    return null
  }
  return (
    (officials ?? []).find((official) => official.id === officialId) ?? null
  )
}
